import styles from "../../../styles/OrderConfirmation.module.scss";
import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useEffect, useState } from "react";
import useLocalStorage from "../../../hooks/useLocalStorage";
import { STRIPE_INFO } from "../constants";
import axios from "axios";

const STRIPE_STATUS = Object.freeze({
  paid: "Payée",
  open: "En cours",
  unpaid: "Impayée",
  void: "Annulée",
  draft: "Brouillon",
  canceled: "Annulée"
})

const STRIPE_PM = Object.freeze({
  card: "Carte Bancaire",
  sepa_debit: "SEPA"
})

const CONTACT_PAGE = "https://nuvee.fr/contactez-nous/"

const OrderConfirmation = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [isAccordionOpen, setIsAccordionOpen] = useState(false);
  const [invoiceData, setInvoiceData] = useState(null);
  const [stripeInfo] = useLocalStorage(STRIPE_INFO);

  const CONSTANT_TEXTS = Object.freeze({
    FIRST: (
      <>
        Dans quelques instants, vous allez recevoir un lien par e-mail
        permettant <span>de finaliser l'activation de votre compte Nuvee.</span>
      </>
    ),
    SECOND: (
      <>
        Vous n'avez pas reçu notre e-mail ?{" "}
        <span>Pensez à bien vérifier vos spams et courriers indésirables.</span>&nbsp; 
        Si votre problème persiste, n'hésitez pas à nous contacter en <a href={CONTACT_PAGE} target="_blank">cliquant ici</a>.
      </>
    ),
  });

  useEffect(async () => {
    if (stripeInfo?.customer) {
      const res = await axios.get(
        process.env.REACT_APP_NUVEE_BASE_URL +
          `/stripe-invoice/retrieve/${stripeInfo.customer}`
      );

      if (res?.data?.length > 0) {
        setInvoiceData(res.data[0]);
      }
    }
  }, [stripeInfo?.customer])

  const toggleAccordion = () => {
    setIsAccordionOpen(!isAccordionOpen);
  }
  
  const openCalendlyPopup = () => {
    window.Calendly.initPopupWidget({ url: 'https://calendly.com/reunion-nuvee/30min' });
    return false;
  }

  useEffect(() => {
    const link = document.createElement("link");
    link.href = "https://assets.calendly.com/assets/external/widget.css";
    link.rel = "stylesheet";
    document.head.appendChild(link);

    const script = document.createElement("script");
    script.src = "https://assets.calendly.com/assets/external/widget.js";
    script.async = true;
    script.onload = () => {
    };
    document.body.appendChild(script);

    return () => {
      document.head.removeChild(link);
      document.body.removeChild(script);
    };
  }, []);

  return (
    <>
      <div className={styles.header}>
        <h1 className={styles.title}>Merci pour votre commande !</h1>
      </div>
      <div className={styles.content}>
        <p>{CONSTANT_TEXTS.FIRST}</p>
        {isMobile ? (
          <div className={styles.accordion}>
            <div
              className={`${styles.accordionHeader} ${
                isAccordionOpen ? styles.open : ""
              }`}
              onClick={toggleAccordion}
            >
              Mail non reçu ?
            </div>
            {isAccordionOpen && (
              <div className={styles.accordionContent}>
                <p>{CONSTANT_TEXTS.SECOND}</p>
              </div>
            )}
          </div>
        ) : (
          <p>{CONSTANT_TEXTS.SECOND}</p>
        )}
        <div className={styles.meeting}>
          <p>Vous souhaitez un <span>accompagnement personnalisé</span> pour votre prise en main de Nuvee ?
            N'hésitez pas, <span>prenez rendez-vous</span> avec nous !</p>
          <div className={styles.meetingButton}>
            <button className={styles.button} onClick={openCalendlyPopup}>Prendre Rendez-Vous</button>
            <img src="/images/liberals/meeting.svg" alt="Prendre rendez-vous" />
          </div>
        </div>
        {(stripeInfo && invoiceData) && (
          <>
            <div className={styles.card}>
              <img
                src={`/images/liberals/recap_payment${isMobile ? "_mobile" : ""}.svg`}
                alt="Confirmation"
              />
              <div className={styles.line}>
                <h2>N° de facture :</h2>
                <span>{invoiceData?.number}</span>
              </div>
              <div className={styles.line}>
                <h2>Fait le :</h2>
                <span>{new Date(invoiceData?.created * 1000)?.toLocaleDateString()}</span>
              </div>
              <div className={styles.line}>
                <h2>Mode de paiement :</h2>
                <span>{STRIPE_PM[invoiceData?.payment_intent?.payment_method?.type]}</span>
              </div>
              <div className={styles.line}>
                <h2>Montant :</h2>
                <span>{(invoiceData?.amount_due / 100).toFixed(2)}</span>
              </div>
              <div className={styles.line}>
                <h2>État de la transaction :</h2>
                <span>{STRIPE_STATUS[invoiceData?.status]?.toUpperCase()}</span>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
}

export default OrderConfirmation;